import type { FaireProductEntity } from "../../entity_types/product";

export const p_1ik86v2k8e: FaireProductEntity = {
  token: "p_1ik86v2k8e",
  type: "product",
  name: "Aardvark Habanero Hot Sauce",
  brandToken: "b_4d833398",
  brandName: "Secret Aardvark Trading Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/ede4fd3fdf1b3a770eb0e82247a7843d94fbe666aadfa7e1c25eca169df904e8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ae58233bac2f803610e20a7d41774e8f59b87e5bab6484a7a61cc3ff774b57f.png",
    "https://cdn.faire.com/fastly/a9a9060d16ce81761b8f40f5120986354db9f083c011e52a6db7f7c03383a168.jpeg",
    "https://cdn.faire.com/fastly/301b7c5d1e398fd529629ec0f5d484fd13bd5558642053568af07fb56310ac6f.jpeg",
    "https://cdn.faire.com/fastly/d379a8edd6069f863c4c515ea13f0879a8fadd0f3528fa82f736c5be483ad45f.jpeg",
    "https://cdn.faire.com/fastly/6925d227cecf6cf2924c21edbbc452d68d1842cc4a92cc2fa760bc0a11a8e3ca.jpeg",
    "https://cdn.faire.com/fastly/1e98cc6a19541bd7ee4a5d7bc1f77dbd4a22705897b605b9f2f5d6d56924f94b.jpeg",
  ],
  priceDollars: 5.67,
  description:
    "This is not your typical hot sauce! While most hot sauces are vinegar-based, Aardvark Habanero Hot Sauce features the sweetness of tomatoes and carrots followed by the heat and flavor of habanero peppers. Our goal is to make your food taste great by finding the balance between flavor and burn. This is a table hot sauce for everyday use. It goes great on eggs, pizza, and tamales; use for marinating any type of meat or tofu. Really, there’s nothing that this can’t go on!\n\nSize: 8 oz, Unit Dimensions: 2x2x6 l x w x h (inches), Case Dimensions: 6.4x4.5x6.5 l x w x h (inches), Case Weight: 3.4lb, Case Cube: (ft)0.205",
  tags: [],
  msrpDollars: 11.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T06:30:57.320Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
